import styled from 'styled-components';

export const SponsorLogoWrapper = styled.div`
  background-color: var(--base-color-black);
  width: 172px;
`;
